import React, { useState, useEffect } from 'react';

import { Modal } from 'antd';

import GridQueryTable from './GridQueryTable';

import GridQueryAction from './GridQueryAction';

const ManageQueriesModal = ({
  setIsMounted,
  visibleManageQueries,
  setVisibleManageQueries,
}) => {
  const [selectedQuery, setSelectedQuery] = useState(null);

  const [editModalVisible, setEditModalVisible] = useState(false);

  useEffect(() => {
    if (visibleManageQueries) setSelectedQuery(null);
  }, [visibleManageQueries]);

  return (
    <Modal
      title='Manage Queries'
      visible={visibleManageQueries}
      onOk={() => setVisibleManageQueries(false)}
      onCancel={() => {
        setVisibleManageQueries(false);
      }}
      width='80vw'
      height='80vh'
      footer={null}
      className='manage-grid__modal'
      destroyOnClose
    >
      {visibleManageQueries ? (
        <>
          <GridQueryAction
            selectedQuery={selectedQuery}
            setSelectedQuery={setSelectedQuery}
            setEditModalVisible={setEditModalVisible}
          />
          <GridQueryTable
            turnOffModal={() => setVisibleManageQueries(false)}
            setIsMounted={setIsMounted}
            selectedQuery={selectedQuery}
            setSelectedQuery={setSelectedQuery}
            editModalVisible={editModalVisible}
            setEditModalVisible={setEditModalVisible}
          />
        </>
      ) : null}
    </Modal>
  );
};

export default ManageQueriesModal;
